var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FEDB41"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEA832"
    },
    d: "M511.28,275.28L374.5,138.5l-24.346-13.998l-43-43.108L219.667,92l-14.821,31L123,184.385 l61.641,61.641l-19.9,184.579l81.179,81.179c3.346,0.13,6.702,0.216,10.079,0.216C390.899,512,501.423,407.658,511.28,275.28z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8B8892"
    },
    d: "M204.846,81.395v62.067h102.308V81.395H204.846z M286.692,123h-61.385v-21.144h61.385V123z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#787780"
    },
    points: "307.154,81.395 307.154,143.462 256,143.462 256,123 286.692,123 286.692,101.856  256,101.856 256,81.395 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AEADB3"
    },
    d: "M142.439,163.923l22.302,266.682h182.518l22.302-266.682H142.439z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#8B8892"
    },
    points: "369.561,163.923 347.259,430.605 256,430.605 256,163.923 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5E5E5"
    },
    d: "M337.846,123H174.154C145.917,123,123,145.917,123,174.154v10.231h266v-10.231 C389,145.917,366.083,123,337.846,123z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.77,
    y: 225.31,
    style: {
      fill: "#E5E5E5"
    },
    width: 20.462,
    height: 164.37
  })), /*#__PURE__*/React.createElement("rect", {
    x: 286.69,
    y: 225.31,
    style: {
      fill: "#C8C6CD"
    },
    width: 20.462,
    height: 164.37
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.85,
    y: 225.31,
    style: {
      fill: "#E5E5E5"
    },
    width: 20.462,
    height: 164.37
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 225.31,
    style: {
      fill: "#C8C6CD"
    },
    width: 10.231,
    height: 164.37
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C8C6CD"
    },
    d: "M389,174.154v10.231H256V123h81.846C366.083,123,389,145.917,389,174.154z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.c2ad9a37.svg";
export { ForwardRef as ReactComponent };